import { createAction } from '@reduxjs/toolkit'

import type { ProjectMovePayload } from './types'

export const ProjectActions = {
  moveToWorkspace: createAction<ProjectMovePayload>('PROJECTS_TO_WORKSPACE'),
}
